/**
 * @file Viewer for a 2D sprite
 * @author Gonzalo Alvarez de Aldecoa <gon@galdecoa.com>
 * @license GPL-3.0-or-later
 * @version 2309.17.001
 */

/** @module spriteviewer */

import { Sprite } from "./Sprite.js";

/** 
 * A viewer a 2D sprite. 
 * @class
 */
class SpriteViewer {

	/** 
	 * The `canvas` element to render the sprite on.
	 * @type {HTMLCanvasElement?} 
	 * @default null
	 */
	#canvas = null;
	/** 
	 * Context where the sprite is to be drawn.
	 * @type {CanvasRenderingContext2D?} 
	 */
	#context = null;

	/** 
	 * The `Sprite` to view.
	 * @type {moduel:sprite~Sprite?} 
	 * @default null
	 */
	sprite = null;

	/**
	 * @type {Boolean}
	 */
	isAnimated = false;

	#onAnimationFrame( timestamp ) {
		window.requestAnimationFrame( this.#handleAnimationFrame );
		this.#context.clearRect( 0, 0, this.#canvas.width, this.#canvas.height );
		if ( this.isAnimated ) {
			this.sprite.cycleFrames( timestamp );
		} else {
			this.sprite.frameNumber = 0;
		}
		this.sprite.draw( timestamp );
	}

	#handleAnimationFrame = this.#onAnimationFrame.bind( this );

	constructor( canvas, sprite ) {
		this.#canvas = canvas;
		this.sprite = sprite;
		this.#context = canvas.getContext( "2d" );
		this.sprite.context = this.#context;
		window.requestAnimationFrame( this.#handleAnimationFrame );
	}

}

export { SpriteViewer }